var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7409 1.91215C15.9966 2.12866 16.0777 2.48853 15.9396 2.79379C15.277 4.25784 15.3415 5.1626 15.6535 5.87538C15.9717 6.60249 16.5711 7.21707 17.3685 8.0347C17.4472 8.11537 17.5278 8.19802 17.6102 8.28294C20.8414 11.6111 21.5353 15.139 20.2637 17.9595C19.011 20.7383 15.9607 22.5701 12.2509 22.7773C8.4888 22.9875 5.14537 21.0956 3.96081 17.9658C2.76354 14.8023 3.88985 10.7226 8.32133 6.77935C8.57665 6.55216 8.95327 6.52631 9.23723 6.71648C9.5212 6.90665 9.64069 7.26475 9.52782 7.58733C8.63073 10.1513 8.62371 11.9721 9.04165 13.053C9.24525 13.5795 9.54322 13.9191 9.88397 14.1184C10.2262 14.3186 10.6712 14.412 11.2267 14.341C12.3675 14.1952 13.0038 13.6126 13.2353 12.8838C13.4789 12.1167 13.3327 10.9993 12.4816 9.73016C11.8617 8.80587 11.5437 7.91461 11.4844 7.06074C11.425 6.20463 11.6292 5.43617 11.9762 4.76578C12.6547 3.45475 13.8918 2.49657 14.8386 1.86166C15.1169 1.67504 15.4852 1.69565 15.7409 1.91215Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/Flame.3c1f8b91d1073d2c2e18ee0ae9985f58.svg";
export { ForwardRef as ReactComponent };